import { useContext } from 'react'

import { AnalyticsContext } from '~/app/features/FragmentRoot/contexts/gallery/AnalyticsContext'

export const useAnalytics = (): Gallery.Analytics.IAnalytics => useContext(AnalyticsContext) as Gallery.Analytics.IAnalytics
